import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js

const EditFranchise = () => {
    const { id } = useParams(); // Get the franchise ID from the URL
    const navigate = useNavigate();

    // State for holding the franchise data
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [location, setLocation] = useState('');
    const [city, setCity] = useState('');

    // Fetch franchise details on component mount
    useEffect(() => {
        fetch(`${BASE_URL}franchises/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.id) {
                    setName(data.name);
                    setEmail(data.email);
                    setPassword(data.password);
                    setLocation(data.location);
                    setCity(data.city);
                }
            })
            .catch(error => console.error('Error fetching franchise details:', error));
    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        const updatedFranchise = {
            name,
            email,
            password,
            location,
            city,
        };

        fetch(`${BASE_URL}franchises/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedFranchise),
        })
            .then(response => response.json())
            .then(data => {
                if (data.id) {
                    // Navigate to the franchise list or show success message
                    alert("Franchise updated successfully!");
                    navigate('/FranchisesList'); // Assuming the route to list is `/FranchisesList`
                } else {
                    alert("Error updating franchise. Please try again.");
                }
            })
            .catch(error => console.error('Error updating franchise:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Franchise</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Franchise Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Franchise Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            placeholder="Enter franchise name"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            className="form-control"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="Enter email"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="password" className="form-label">Password</label>
                                        <input
                                            type="password"
                                            id="password"
                                            className="form-control"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            placeholder="Enter password"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="location" className="form-label">Location</label>
                                        <input
                                            type="text"
                                            id="location"
                                            className="form-control"
                                            value={location}
                                            onChange={(e) => setLocation(e.target.value)}
                                            placeholder="Enter location"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="city" className="form-label">City</label>
                                        <input
                                            type="text"
                                            id="city"
                                            className="form-control"
                                            value={city}
                                            onChange={(e) => setCity(e.target.value)}
                                            placeholder="Enter city"
                                            required
                                        />
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Franchise</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Edit Franchise Form */}
        </div>
    );
};

export default EditFranchise;
